import React, { useEffect, useState } from 'react';

import { getEdlySiteConfig, updateEdlySiteConfig } from 'services/siteConfiguration';
import 'pages/integrations/containers/DiscussionContainer/Components/DisableStyle.css';

import { messageNotification } from 'helpers';

const DiscussionDisable = ({ badges, dispatch }) => {
  const [checked, setCheckedBox] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getEdlySiteConfig()
      .then((res) => {
        const settings = res.data.lms;
        setCheckedBox(settings.FEATURES.ENABLE_DISCUSSION_HOME_PANEL);
      })
      .catch((error) => {
        messageNotification('danger', 'Error', `${error}`);
      });
  }, []);

  const handleClick = async () => {
    const updateCheck = !checked;
    setIsLoading(true);
    setCheckedBox(updateCheck);
    const data = {
      lms: {
        FEATURES: {
          ENABLE_DISCUSSION_HOME_PANEL: updateCheck,
          ENABLE_DISCUSSION_SERVICE: updateCheck
        }
      }
    };
    updateEdlySiteConfig(data)
      .then((res) =>
        messageNotification(
          'success',
          'Key updated',
          `Discussion forum has been ${updateCheck ? 'enabled' : 'disabled'}`
        )
      )
      .catch((error) => {
        messageNotification('danger', 'Error', `${error}`);
        setCheckedBox(!updateCheck);
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="integration-holder mb-4">
      <h4 className="mb-4">Discussion Forum </h4>
      <div className="subheader-holder">
        <h5>1. Enable/Disable Discussion Forum</h5>
        <div className="checkbox_Container d-flex align-items-center">
          <p className="m-0">Toggle the button to {`${!checked ? 'enable' : 'disable'}`} discussion forum</p>

          <input type="checkbox" checked={checked} className="checkbox" onChange={handleClick} />
          {isLoading && (
            <small className="text-muted ms-2 d-flex align-items-center">
              <span
                className="spinner-border me-1"
                role="status"
                style={{ width: '0.75rem', height: '0.75rem' }}
              ></span>
              Saving...
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default DiscussionDisable;
